<template>
<!-- component to display all the contact -->
<nav class="navbar navbar-expand-lg navbar-light" id="mainNav">
    <div class="container px-4 px-lg-5">
        <a class="navbar-brand" href="index.html"><img src="../assets/img.png"  class="img-fluid rounded-circle" width="50px" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
        aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavId">
            <ul class="navbar-nav ms-auto py-4 py-lg-0">
                <li class="nav-item"><router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/admin">Home</router-link></li>
                <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="about.html">Admin</a></li>
                <!-- <li class="nav-item"><button class="nav-link mt-2  btn btn-white">Print Form</button></li> -->

            </ul>
        </div>
    </div>
 </nav>
    <section class="ftco-section"  style="margin-top:150px">
        <button @click="downloadFile" title="Download the ecxel file" class="shadow-lg rounded-circle btn-download  btn btn-secondary py-3 px-4"> <i class="fa fa-download"></i> </button>
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="card border-0 shadow">
                        <div class="card-body card-list">
                            <div class="card-text">
                                No Admitted Students
                                <h3>{{totaladmitted}}</h3>
                            </div>
                            <div class="clear-fix">
                                <div class="float-end">
                                    <span class="fa fa-user text-secondary"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card border-0 shadow">
                        <div class="card-body card-list">
                            <div class="card-text">
                                No of All Applicants
                                <h3>{{totalApplicants ? totalApplicants :'0'}}</h3>
                            </div>
                            <div class="clear-fix">
                                <div class="float-end">
                                    <span class="fa fa-users text-secondary"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card border-0 shadow">
                        <div class="card-body card-list">
                            <div class="card-text">
                                No of pendding
                                <h3>0</h3>
                            </div>
                            <div class="clear-fix">
                                <div class="float-end">
                                    <span class="fa fa-user text-secondary"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row ">
                <div class="col-md-6  mb-5">
                    <!-- <h2 class="heading-section">Contact List</h2> -->
                </div>
            </div>
            <!--  -->
            <div class="row">
                <!--  -->
                <div class="col-md-12">
                    <div class="table-wrap">
                        <table class="table table-responsive-xl">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Email</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <!-- tbody -->

                        <tbody>
                            <div v-show="show" style="font-size:25px" class="text-center"> <span class="fa fa-spin fa-spinner"></span> Network error</div>
                            <tr  v-for="(applicant, i) in allAppllicants" :key="i" v-show="show2">
                                <td>
                                   <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" :value="applicant._id">
                                    <label class="form-check-label" for="inlineCheckbox1"></label>
                                    </div>
                                </td>
                                <td class="d-flex align-items-center">
                                    <!-- <div ></div> -->
                                    <img :src="applicant.image_url" class="rounded-circle img"  alt="">
                                    <div class="pl-3 email">
                                        <span>{{applicant.email}}</span>
                                        <span>DOB: {{applicant.date}}</span>
                                    </div>
                                </td>
                                <td><div class="names">{{applicant.firstname}}{{applicant.lastname}}</div> </td>
                                <td class="status"><span :class="applicant.status=='not yet'? 'not_active ' : 'active'">{{applicant.status}}</span></td>
                                <td>
                                    <button type="button"  @click="viewProfile(applicant._id)" class="close btn btn-secondary">
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        </tbody>

                        </table>
                    </div>
                </div>
                <!-- col /end here -->
            </div>
            <!-- row end here -->
        </div>
    </section>
</template>

<script>
import Axios from'axios'
import exportFromJSON from "export-from-json"
// import axios from 'axios'
export default {
    data(){
        return{ 
            allAppllicants:'',
            totalApplicants:'',
            totaladmitted:'',
            show:false,
            show2:true
        }
    },
    methods:{
        viewProfile(id){
            this.$router.push('/admin/student_profile/'+ id)
        },
        downloadFile() {
            const data = this.allAppllicants;
            const fileName = "np-data";
            const exportType = exportFromJSON.types.csv;
            if (data) exportFromJSON({ data, fileName, exportType });
        },
        getto(){
            const url = "https://stormy-ravine-66505.herokuapp.com/api/admit"
            Axios.get(url).then(res=>{
                this.totaladmitted = res.data.response.length
            })
        }
    },

    mounted(){
        const URL = "https://stormy-ravine-66505.herokuapp.com/api/info"
        Axios.get(URL).then(res => {
                this.allAppllicants = res.data.response
                this.totalApplicants = this.allAppllicants.length
                console.log(this.totalApplicants)
        }).catch(err => {
            if (err){
                this.show = true
                this.show2 = false
            }
        })
        this.getto()
    }
}
</script>

<style lang="css" src="./admin.css" scoped>
  
</style>